import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SOTService } from '../../services';

@Component({
  selector: "sot-paymentconfirmation",
  templateUrl: "./paymentconfirmation.component.html",
  styleUrls: ["./paymentconfirmation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentConfirmationComponent implements OnInit, OnDestroy {

  private _resetAfterPaymentSubscription: Subscription;
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;
  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
    console.debug("--- sot-paymentconfirmation constructor")
  }

  public ngOnInit(): void {
    console.debug("--- sot-paymentconfirmation ngOnInit")
    const me = this;
    me.isModeOne = me._sotService.useModeOne();
    me.isModeTwo = me._sotService.useModeTwo();
    me._resetAfterPaymentSubscription = me._sotService.evResetAfterPayment.subscribe(() => { me.resetAfterPaymentComplete() });
    me.PushChanges();
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-paymentconfirmation ngOnDestroy")
    if (this._resetAfterPaymentSubscription) {
      this._resetAfterPaymentSubscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("PaymentConfirmationComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public get order_no(): string {
    return this._sotService.currentOrderNo;
  }

  /** Whether there are more than 3 bonus actions */
  public get hasMoreBonus(): boolean {
    return this._sotService.currentOrderBonusPoints.length > 3;
  }

  /** Nach der Bezahlung ist noch ein offener Betrag geblieben */
  public get order_open_amount(): number {
    return this._sotService.currentOrderOpenAmount;
  }

  /** Erhaltene Bonus Punkte */
  public get order_bonus_points(): { label_de: string, points: number }[] {
    return this._sotService.currentOrderBonusPoints.slice(0, 3);
  }

  public get hasCollectedBonusPoints(): boolean {
    return this.order_bonus_points && this.order_bonus_points.length > 0;
  }

  //TODO POS & Backend
  public get redeemBenefitStateFailed(): boolean {
    return this._sotService.redeemBenefitStateFailed;
  }

  /** reagiert, wenn das POS mitteilt das der Bon gezogen wurde */
  private resetAfterPaymentComplete(): void {
    this._sotService.GoToStartscreen();
  }

  public countdownStatusChanged(status: "start" | "stop" | "done"): void {
    if (status == "done") {
      this._sotService.GoToStartscreen();
      this._sotService.StopInactiveDialogTimer();
    } // else ignore
    else if (status == "stop") {
      this._sotService.StartInactiveDialogTimer();
    } else {
      this._sotService.StopInactiveDialogTimer();
    }
  }

  public get show_questions(): boolean {
    return false; // momentan werden keine fragen gestellt
  }

  public newOrder(): void {
    this._sotService.GoToOrdertype();
  }
}
